import moment from "moment";
import { createContext, useEffect, useState } from "react";
import "./ImportTailwind.css";
// import { useLocation } from "react-router-dom";

export const Context = createContext({
  showDrawerSidebar: false,
  setShowDrawerSidebar: () => { },
});

export const ContextProvider = ({ children }) => {

  // ---------------- DRAWER SIDEBAR START ------------------------------------
  const [showDrawerSidebar, setShowDrawerSidebar] = useState(false);
  const [innerWidth, setInnerWidth] = useState(window.innerWidth);

  // PATIENT REGISTER TAILWIND INJECTOR
  // const location = useLocation()

  // useEffect(() => {
  //   const tailwindRoutes = [
  //     "/new_patient_intake",
  //     "/analytics",
  //     "newprogram",
  //     "protocol",
  //     "template",
  //     "details",
  //   ];

  //   const path = location.pathname;

  //   const matchesUpload = /^\/upload\/[^/]+\/[^/]+$/.test(path);

  //   const shouldLoad =
  //     matchesUpload ||
  //     tailwindRoutes.some(
  //       (route) => path === route || path.includes(route)
  //     );

  //   if (shouldLoad) {
  //     import("./ImportTailwind.css");
  //   }
  // }, [location.pathname]);

  useEffect(() => {
    const handleResize = () => {
      setInnerWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // ---------------- DRAWER SIDEBAR START ------------------------------------




  // ---------------- Appointments START ------------------------------------
  const [appointments, setAppointments] = useState([]);
  const [contentAppointnentsLoaded, setContentAppointnentsLoaded] = useState(false);
  // ---------------- Appointments END ------------------------------------

  // ---------------- Monitoring START ------------------------------------
  const [patientMonitoringData, setPatientMonitoringData] = useState([]);
  const [contentMonitoringLoaded, setContentMonitoringLoaded] = useState(false);
  // ---------------- Monitoring END ------------------------------------

  // ----------------- Programs START ------------------------------------
  const [programsData, setProgramsData] = useState([]);
  const [protocolsData, setProtocolsData] = useState([]);
  const [contentProgramsLoaded, setContentProgramsLoaded] = useState(false);
  // ----------------- Programs START ------------------------------------


  // ----------------- Workouts START ------------------------------------
  const [workoutsData, setWorkoutsData] = useState([]);
  const [contentWorkoutsLoaded, setContentWorkoutsLoaded] = useState(false);
  // ----------------- Workouts END ------------------------------------


  // ----------------- myPatients START ------------------------------------
  const [patientsData, setPatientsData] = useState([]);
  const [contentPatientsLoaded, setContentPatientsLoaded] = useState(false);
  // ----------------- myPatients END ------------------------------------


  // ----------------- Reports START ------------------------------------
  const [reportsData, setReportsData] = useState([]);
  const [contentReportsLoaded, setContentReportsLoaded] = useState(false);

  let dateYesterday = new Date(new Date().setDate(new Date().getDate() - 1));
  let dateShow = moment(dateYesterday).format("l");
  const [patientDate, setDate] = useState(dateShow);
  const [dateInUse, setDateInUse] = useState("y");
  // ----------------- Reports END ------------------------------------


  // ------------------ Questionnaire START --------------------------------
  const [questionnaireData, setQuestionnaireData] = useState([]);
  const [contentQuestionnaireLoaded, setContentQuestionnaireLoaded] = useState(false);
  // ------------------ Questionnaire END ----------------------------------


  // ------------------ Clients START --------------------------------
  const [clientsData, setClientsData] = useState([]);
  const [contentClientsLoaded, setContentClientsLoaded] = useState(false);
  // ------------------ Clients END --------------------------------


  // ------------------ Settings START --------------------------------
  const [membersData, setMembersData] = useState([]);
  const [therapistTabData, setTherapistTabData] = useState([]);
  const [contentLoaded, setContentLoaded] = useState(false);
  // ------------------ Settings END --------------------------------

  function clearAllData() {
    setShowDrawerSidebar(false);
    setAppointments([])
    setContentAppointnentsLoaded(false)
    setPatientMonitoringData([])
    setContentMonitoringLoaded(false)
    setProgramsData([])
    setProtocolsData([])
    setContentProgramsLoaded(false)
    setWorkoutsData([])
    setContentWorkoutsLoaded(false)
    setPatientsData([])
    setContentPatientsLoaded(false)
    setReportsData([])
    setContentReportsLoaded(false)
    setDate(dateShow)
    setDateInUse("y")
    setQuestionnaireData([])
    setContentQuestionnaireLoaded(false)
    setClientsData([])
    setContentClientsLoaded(false)
    setMembersData([])
    setTherapistTabData([])
    setContentLoaded(false)
  }

  const [saveExerciseBuilder, setSaveExerciseBuilder] = useState(false);

  return (
    <Context.Provider
      value={{
        showDrawerSidebar,
        setShowDrawerSidebar,
        innerWidth,

        // APPOINTMENTS START
        appointments, setAppointments, contentAppointnentsLoaded, setContentAppointnentsLoaded,
        // APPOINTMENTS END

        // MONITORINGS START
        patientMonitoringData, setPatientMonitoringData, contentMonitoringLoaded, setContentMonitoringLoaded,
        // MONITORINGS END

        // PROGRAMS START
        programsData, setProgramsData, protocolsData, setProtocolsData, contentProgramsLoaded, setContentProgramsLoaded,
        // PROGRAMS END

        // WORKOUTS START
        workoutsData, setWorkoutsData, contentWorkoutsLoaded, setContentWorkoutsLoaded,
        // WORKOUTS END

        // PATIENTS START
        patientsData, setPatientsData, contentPatientsLoaded, setContentPatientsLoaded,
        // PATIENTS END

        // REPORTS START
        reportsData, setReportsData, contentReportsLoaded, setContentReportsLoaded, patientDate, setDate, dateInUse, setDateInUse,
        // REPORTS END

        // Questionnaire START
        questionnaireData, setQuestionnaireData, contentQuestionnaireLoaded, setContentQuestionnaireLoaded,
        // Questionnaire END

        // CLIENTS START
        clientsData, setClientsData, contentClientsLoaded, setContentClientsLoaded,
        // CLIENTS END

        // SETTINGS START
        membersData, setMembersData, therapistTabData, setTherapistTabData, contentLoaded, setContentLoaded,
        // SETTINGS END

        // CLEAR DATA
        clearAllData,

        // EXERCISE BUILDER SAVE
        saveExerciseBuilder, setSaveExerciseBuilder

      }}
    >
      {children}
    </Context.Provider>
  );
};
